import axios from 'axios';

class AgreeInfoService {
  // [c-01] DFD-RSV-WEBS-CCRC-POPUP 동의항목 팝업 화면 구성
  async excuteAgreeInfo({ ccrcGuidId, hspCd, hspId }) {
    // CORS 대응이후 url 환경변수 사용으로 변경
    // return axios.get(`/mock/ccrcpopup.json`);
    return axios.get(
      `${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/ccrcpopup/${ccrcGuidId}/${hspCd}/${hspId}`,
    );
  }
}
export default new AgreeInfoService();
